export default "__VITE_ASSET__Cn_QirG4__"